import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "../../../gen/tableNames/tables";
import { parseDate } from "@/lib/utils";

export type G4SustainAnalytics = {
  id: number;
  date?: Date;
  sustainalytics_id?: number;
  esg_risk_score?: number;
  environment_risk_score?: number;
  social_risk_score?: number;
  governance_risk_score?: number;
  country_risk_score?: number;
  carbon_emissions_scope_1?: number;
  carbon_emissions_scope_2?: number;
  carbon_emissions_scope_3?: number;
  evic_sfdr?: number;
  created_at?: string | null;
  updated_at?: string | null;
};

const t = (key: string, defaultValue: string) =>
  i18n.t(`${Tables.G4_SUSTAINALYTICS_ESG}.columns.${key}`, {
    ns: "tables",
    defaultValue,
  });

export const g4_sustainanalytics_columns: ColumnDef<G4SustainAnalytics>[] = [
  {
    accessorKey: "id",
    header: t("id", "ID"),
  },
  {
    accessorKey: "date",
    header: () => t("date", "Date"),
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {row.getValue("date")
            ? parseDate(String(row.getValue("date")))
            : null}
        </div>
      );
    },
  },
  {
    accessorKey: "sustainalytics_id",
    header: () => t("sustainalytics_id", "Sustainalytics id"),
  },
  {
    accessorKey: "esg_risk_score",
    header: () => t("esg_risk_score", "ESG risk score"),
  },
  {
    accessorKey: "environment_risk_score",
    header: () => t("environment_risk_score", "Environment risk score"),
  },
  {
    accessorKey: "social_risk_score",
    header: () => t("social_risk_score", "Social risk score"),
  },
  {
    accessorKey: "governance_risk_score",
    header: () => t("governance_risk_score", "Government risk score"),
  },
  {
    accessorKey: "country_risk_score",
    header: () => t("country_risk_score", "Country risk score"),
  },
  {
    accessorKey: "carbon_emissions_scope_1",
    header: () => t("carbon_emissions_scope_1", "Carbon emission scope 1"),
  },
  {
    accessorKey: "carbon_emissions_scope_2",
    header: () => t("carbon_emissions_scope_2", "Carbon emission scope 2"),
  },
  {
    accessorKey: "carbon_emissions_scope_3",
    header: () => t("carbon_emissions_scope_3", "Carbon emission scope 3"),
  },
  {
    accessorKey: "evic_sfdr",
    header: () => t("evic_sfdr", "Evic Sfdr"),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
